import { useQuery } from '@apollo/client/react'

import { PORTAL_PM_HAS_PMS_INTEGRATION } from 'src/lib/businessPortal/portalPmQueries'

/**
 * Manual-entry PMs have no active PMS integration (Yardi/Entrata/AppFolio/RealPage);
 * they can hand-create properties and applications from the portal.
 */
export function usePortalManualEntryPm(
  pmName: string | null | undefined,
  enabled = true
) {
  const { data, loading } = useQuery<{ portalPmHasPmsIntegration: boolean }>(
    PORTAL_PM_HAS_PMS_INTEGRATION,
    {
      variables: { pmName: pmName ?? '' },
      skip: !pmName || !enabled,
    }
  )

  const hasPms = data?.portalPmHasPmsIntegration

  return {
    loading,
    hasPms,
    isManualEntry: hasPms === false,
  }
}
